<ng-template #occupationCell>
  <div [ngClass]="{disabled: occupation.endDate}">
    <b>č. {{occupation.zabcis}}</b>
    <div *ngIf="occupation.zabtyptx">
      {{occupation.zabtyptx}}
    </div>
    <div *ngIf="occupation.zabvym">
      {{occupation.zabvym}} <span class="unit">m<sup>2</sup></span>
    </div>
    <div *ngIf="occupation.nabyvatel">Nabyvatel: {{occupation.nabyvatel}}</div>
    <div *ngIf="occupation.priorityIndex !== null && priorityEnabled" class="no-wrap">{{occupation | priorityIndexName}}</div>
    <div *ngIf="occupation.investor">Investor: {{occupation.investor}}</div>
    <ng-container *ngIf="visibleFinalSolutionType && visibleApprove">
      <div class="flexbox-container flex-vertical-centered">
        <span class="no-wrap mt-5"> {{ occupation.finalSolutionState === FinalSolutionStateEnum.PENDING ? "Stav ke schválení: " + occupation.finalSolutionType.name : occupation.finalSolutionType.name }}
        </span>
        <span *ngIf="occupation?.finalSolutionState === FinalSolutionStateEnum.APPROVED"
            class="tag tag--active tag--not-clickable ml-5 occupation-solution-state-indicator"
            [tooltip]="tooltipFinalSolutionStateComponent"
            [data]="occupation">
        </span>
        <span *ngIf="occupation?.finalSolutionState === FinalSolutionStateEnum.REJECTED"
              class="tag tag--danger tag--not-clickable ml-5 occupation-solution-state-indicator"
              [tooltip]="tooltipFinalSolutionStateComponent"
              [data]="occupation">
        </span>
      </div>
      <div class="flexbox-container no-wrap mt-5" *ngIf="occupation?.finalSolutionState === FinalSolutionStateEnum.PENDING && canApproveFinalSolutionType">
        <a class="button"
           (click)="onApproveOccupation(occupation)">
          Schválit
        </a>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #occupationCellShowOnlyEdit>
  <div class="fill-content flexbox-container flex-vertical-centered p-10">
    <span class="flex-rest" >{{ occupation.zabcis }}</span>
  </div>
</ng-template>

<ng-template #occupationPhaseCell>
  <div>
    {{ occupation.zabst }}
  </div>
</ng-template>

  <div *ngIf="!occupation.endDate" class="fill-content">
    <div class="content-wrap">
      <ng-container *ngTemplateOutlet="type === 'phase' ? occupationPhaseCell : type === 'edit' ? occupationCellShowOnlyEdit : occupationCell"></ng-container>
      <div class="flex1" *ngIf="showUpdate">
        <a class="fr button" uiSref=".updateOccupation" [uiParams]="{occupationId: occupation.id}">
          <i class="fa fa-pencil"></i>
        </a>
      </div>
    </div>
  </div>

  <div *ngIf="occupation.endDate"
       [tooltip]="tooltipComponent"
       [activeContent]="true"
       [data]="{ filter: { filters: { occupationId: occupation.id }}, customData: { occupation: occupation }}"
       class="tooltip-hover-area fill-content"
  >
    <div class="content-wrap">
      <div class="mr-10"><span class="error-message"><i class="fa fa-exclamation-triangle"></i></span></div>
      <ng-container *ngTemplateOutlet="type === 'phase' ? occupationPhaseCell : type === 'edit' ? occupationCellShowOnlyEdit : occupationCell"></ng-container>
      <div class="flex1" *ngIf="showSwitch">
        <a class="fr button" gmtAuth="admin" uiSref="symap.project.cases.detail.updateOccupation" [uiParams]="{occupationId: occupation.id}">
          <i class="fa fa-pencil"></i>
        </a>
      </div>
    </div>
  </div>
